export const getAuthErrorMessage = (error) => {
  if (!error?.code && error?.message) {
    return error.message;
  }

  const errorMessages = {
    "auth/invalid-email": "El correo electrónico no tiene un formato válido.",
    "auth/user-disabled":
      "La cuenta está deshabilitada. Ponte en contacto con el soporte.",
    "auth/user-not-found":
      "No hay una cuenta registrada con este correo electrónico.",
    "auth/invalid-credential": "Las credenciales ingresadas son incorrectas.",
    "auth/too-many-requests":
      "Se realizaron demasiados intentos fallidos. Vuelve a intentarlo más tarde.",
    "auth/network-request-failed":
      "Error de red. Comprueba tu conexión a internet.",
  };

  if (errorMessages[error.code]) {
    return errorMessages[error.code];
  }

  return "Se produjo un error desconocido. Vuelve a intentarlo.";
};
